// src/services/api/fault-report.service.ts

import api from '../index';
import { FaultReport } from '../../types/faultReport';

export const faultReportService = {
  create: async (formData: FormData) => {
    return api.post<{ message: string; fault_report: FaultReport }>(
      '/fault-reports',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  },

  getAll: async (params?: { status?: string; page?: number }) => {
    return api.get<{ data: FaultReport[]; total: number }>(
      '/fault-reports',
      { params }
    );
  },

  getById: async (id: number) => {
    return api.get<FaultReport>(`/fault-reports/${id}`);
  },

  update: async (id: number, data: Partial<FaultReport>) => {
    return api.put<{ message: string; fault_report: FaultReport }>(
      `/fault-reports/${id}`,
      data
    );
  },

  getNotifications: async () => {
    return api.get('/fault-reports/notifications');
  },

  markNotificationAsRead: async (id: string) => {
    return api.post(`/fault-reports/notifications/${id}/read`);
  }
};

export default faultReportService;